import React, { ReactElement, useEffect, useState } from 'react';
import { StyledRadio, StyledMark, HiddenRadio, RadioContainer, RadioLabel } from './Radio.styled';
import { ComponentProps as Props } from './Radio.types';

const Radio: React.FC<Props> = ({
  mode = 'primary',
  checked,
  label,
  labelPosition = 'right',
  onClick,
  preventDeselect = false,
  ...props
}): ReactElement<Props> => {
  const [isChecked, setIsChecked] = useState<boolean>(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleOnClick = (event: React.MouseEvent) => {
    if (!props.disabled && !(isChecked && preventDeselect)) {
      setIsChecked(!isChecked);
    }

    if (onClick) {
      onClick(event);
    }
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);

    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <RadioContainer m={1} className={props.className} labelPosition={labelPosition}>
      <HiddenRadio type="radio" name={props.name} checked={isChecked} onChange={handleOnChange} {...props} />
      <StyledRadio m={2} mode={mode} isDisabled={props.disabled} onClick={handleOnClick}>
        {isChecked ? <StyledMark isDisabled={props.disabled} mode={mode} /> : null}
      </StyledRadio>
      {label && (
        <RadioLabel htmlFor={props.id} isDisabled={props.disabled}>
          {label}
        </RadioLabel>
      )}
    </RadioContainer>
  );
};

export default Radio;
